
import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <main className="contact-page">

      {/* HERO SECTION */}
      <section className="contact-hero">
        <div className="container">
          <div className="contact-hero-content">
            <h1>
              Get In <span>Touch</span>
            </h1>

            <p>
              Have a question or need more information?
              Connect with Air Force School, Vayu Sena Nagar,
              Nagpur. We would be happy to assist you.
            </p>

            <div className="contact-breadcrumb">
              <a href="/">Home</a>
              <i className="bi bi-chevron-right"></i>
              <span>Contact Us</span>
            </div>
          </div>
        </div>

        <div className="contact-hero-shape"></div>
      </section>

      {/* CONTACT INFORMATION + ENQUIRY FORM */}
      <section className="contact-main-section">
        <div className="container">

          <div className="contact-main-heading">
            <h2>
              We'd Love to <strong>Hear From You</strong>
            </h2>
            <p>
              Get in touch with our school for admissions,
              academic information or general enquiries.
            </p>
          </div>

          <div className="row g-0 contact-main-wrapper">

            {/* LEFT SIDE - CONTACT DETAILS */}
            <div className="col-lg-5">
              <div className="contact-left-panel">

                <span className="contact-panel-tag">
                  GET IN TOUCH
                </span>

                <h2>
                  Let's Connect
                  <span> With Our School</span>
                </h2>

                <p className="contact-left-description">
                  We are happy to assist parents, students
                  and visitors. Reach out to our school office
                  for any information or assistance.
                </p>

                <div className="contact-panel-details">

                  {/* ADDRESS */}
                  <div className="contact-detail">
                    <div className="contact-detail-icon">
                      <i className="bi bi-geo-alt-fill"></i>
                    </div>

                    <div>
                      <h5>School Address</h5>
                      <p>
                        Air Force School,<br />
                        Vayu Sena Nagar,<br />
                        Nagpur, Maharashtra, India.
                      </p>
                    </div>
                  </div>

                  {/* LANDLINE */}
                  <div className="contact-detail">
                    <div className="contact-detail-icon">
                      <i className="bi bi-telephone-fill"></i>
                    </div>

                    <div>
                      <h5>Phone Number</h5>
                      <p>
                        <a href="tel:07122511407">
                          0712-2511407
                        </a>
                      </p>
                    </div>
                  </div>

                  {/* MOBILE */}
                  <div className="contact-detail">
                    <div className="contact-detail-icon">
                      <i className="bi bi-phone-fill"></i>
                    </div>

                    <div>
                      <h5>Mobile Number</h5>
                      <p>
                        <a href="tel:9146071487">
                          9146071487
                        </a>
                      </p>
                    </div>
                  </div>

                </div>

                {/* SOCIAL MEDIA */}
                <div className="contact-panel-social">
                  <h5>Follow Our Updates</h5>

                  <div>
                    <a
                      href="https://www.facebook.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <i className="bi bi-facebook"></i>
                    </a>

                    <a
                      href="https://www.instagram.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                    >
                      <i className="bi bi-instagram"></i>
                    </a>

                    <a
                      href="https://www.youtube.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="YouTube"
                    >
                      <i className="bi bi-youtube"></i>
                    </a>
                  </div>
                </div>

                <div className="contact-panel-decoration">
                  <i className="bi bi-send-fill"></i>
                </div>

              </div>
            </div>

            {/* RIGHT SIDE - ENQUIRY FORM */}
            <div className="col-lg-7">
              <div className="contact-form-panel">

                <span className="contact-form-tag">
                  SEND AN ENQUIRY
                </span>

                <h3>How Can We Help You?</h3>

                <p>
                  Fill in the details below and share your
                  enquiry with our school office.
                </p>

                <form
                  className="school-contact-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    alert(
                      "Please connect this form to your backend to receive enquiries."
                    );
                  }}
                >

                  <div className="row g-3">

                    <div className="col-md-6">
                      <label htmlFor="contactName">
                        Full Name *
                      </label>

                      <input
                        type="text"
                        id="contactName"
                        name="name"
                        placeholder="Enter your full name"
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="contactPhone">
                        Phone Number *
                      </label>

                      <input
                        type="tel"
                        id="contactPhone"
                        name="phone"
                        placeholder="Enter phone number"
                        pattern="[0-9+\-\s]{10,15}"
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="contactEmail">
                        Email Address
                      </label>

                      <input
                        type="email"
                        id="contactEmail"
                        name="email"
                        placeholder="Enter your email"
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="contactSubject">
                        Enquiry Type *
                      </label>

                      <select
                        id="contactSubject"
                        name="subject"
                        defaultValue=""
                        required
                      >
                        <option value="" disabled>
                          Select enquiry type
                        </option>

                        <option value="Admission Enquiry">
                          Admission Enquiry
                        </option>

                        <option value="Academic Enquiry">
                          Academic Enquiry
                        </option>

                        <option value="General Enquiry">
                          General Enquiry
                        </option>

                        <option value="Other">
                          Other
                        </option>
                      </select>
                    </div>

                    <div className="col-12">
                      <label htmlFor="contactMessage">
                        Your Message *
                      </label>

                      <textarea
                        id="contactMessage"
                        name="message"
                        rows="5"
                        placeholder="Write your message here..."
                        required
                      ></textarea>
                    </div>

                    <div className="col-12">
                      <button
                        type="submit"
                        className="contact-submit-btn"
                      >
                        Send Enquiry
                        <i className="bi bi-arrow-right"></i>
                      </button>
                    </div>

                  </div>
                </form>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* GOOGLE MAP */}
      <section className="contact-map-section">
        <div className="container">

          <div className="contact-section-heading">

            <h2>
              Visit <strong>Our School</strong>
            </h2>

            <p>
              Find Air Force School, Vayu Sena Nagar, Nagpur.
            </p>
          </div>

          <div className="contact-map-frame">
            <iframe
              title="Air Force School Vayu Sena Nagar Nagpur"
              src="https://www.google.com/maps?q=Air+Force+School+Vayu+Sena+Nagar+Nagpur&output=embed"
              width="100%"
              height="400"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            ></iframe>
          </div>

        </div>
      </section>

    </main>
  );
}

export default Contact;
